export default __webpack_public_path__ + "static/media/present-a-new-business-idea.ab628ac1.svg";